export const FETCH_PLANS = 'FETCH_PLANS';
export const FETCH_PLANS_SUCCESS = 'FETCH_PLANS_SUCCESS';
export const FETCH_PLANS_FAIL = 'FETCH_PLANS_FAIL';

export const FETCH_CUSTOM_PLAN = 'FETCH_CUSTOM_PLAN';
export const FETCH_CUSTOM_PLAN_SUCCESS = 'FETCH_CUSTOM_PLAN_SUCCESS';
export const FETCH_CUSTOM_PLAN_FAIL = 'FETCH_CUSTOM_PLAN_FAIL';

export const FETCH_RESET_CUSTOM_PLAN = 'FETCH_RESET_CUSTOM_PLAN';
